/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Note;
(function (Note) {
    var noteType;
    (function (noteType) {
        noteType["PRICE_LOGIC"] = "Price Logic";
        noteType["ENGINEERING"] = "Engineering";
        noteType["NO_BID"] = "No Bid";
        noteType["PROPRIETARY"] = "Proprietary";
        noteType["RESTRICTION"] = "Restriction";
    })(noteType = Note.noteType || (Note.noteType = {}));
})(Note || (Note = {}));
